/*
 * 点赞去重：localStorage 记录已点赞的记录 id，跨首页/详情页共用。
 * 服务端 /digg 接口本身不判重，重复点赞会被 +1，这里做客户端防重。
 */
import store from "./store";

const getStoredDiggs = () => {
    try {
        const saved = JSON.parse(store.get("diggArr") || "[]");
        return Array.isArray(saved) ? saved : [];
    } catch {
        return [];
    }
};

export const hasStoredDigg = (objectId) =>
    getStoredDiggs().some((entry) =>
        typeof entry === "string" ? entry === objectId : entry?.id === objectId,
    );

export const rememberDigg = (objectId) => {
    const saved = getStoredDiggs();
    if (!hasStoredDigg(objectId)) saved.push({ id: objectId });
    store.set("diggArr", JSON.stringify(saved));
};
